import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/api/user.service';
import { ApiRequestService } from 'src/app/services/api-request.service';
import { GlobalService } from 'src/app/services/global.service';
import { LanguageService } from 'src/app/services/language.service';
import { MiniStatusService } from 'src/app/services/mini-status.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { IPopup } from '../IPopup';

@Component({
  selector: 'app-user-find-popup',
  templateUrl: './user-find-popup.component.html',
  styleUrls: ['./user-find-popup.component.scss'],
})
export class UserFindPopupComponent implements OnInit, AfterViewInit, IPopup {
  @ViewChild('basePopup') basePopup;
  @ViewChild('phraseEdit') phraseEdit;
  public userToFind = '';
  public popupName = 'FilterUsers';
  public closed: EventEmitter<void> = new EventEmitter();

  constructor(
    public lang: LanguageService,
    private rs: ApiRequestService,
    private ms: MiniStatusService,
    private t: ToasterService,
    private router: Router,
    private g: GlobalService,
    private us: UserService
  ) {}

  ngOnInit(): void {}
  ngAfterViewInit() { this.show(); }

  public confirmSearch() {
    this.basePopup.hidePopup();
    this.ms.show(this.lang.get('general.pleaseWait'));
    this.router.navigate([...this.g.getHomeUrl(), 'filtered-users']);
    const that = this;
    this.rs
      .post(
        '/filter-users',
        {
          role: -1,
          sort: 0,
          searchPhrase: this.userToFind,
          searchFields: [],
        },
        true
      )
      .subscribe(
        (result) => {
          that.ms.hide();
          if (!result.success) {
            that.t.postError(result.error);
          } else {
            that.us.filteredUsers = [];
            for (const iUser of result.list.data) {
              that.us.filteredUsers.push(iUser);
            }
          }
        },
        (error) => {
          that.t.postError(that.lang.get('auth.errors.serverSideError'));
          that.ms.hide();
        }
      );
  }

  public show() {
    this.phraseEdit.focusEdit();
  }
}
